//React
import React from 'react';

// Tanstack Query
import { QueryClient } from '@tanstack/react-query';

//Pages
import { UploadManagement } from 'pages/uploads';

//Store
import { useAdminUploadManagementData } from './useAdminUploadManagementData';

interface AdminUploadManagementProps {
  queryClient: QueryClient;
}

export const AdminUploadManagement: React.FC<AdminUploadManagementProps> = ({
  queryClient,
}) => {
  const {
    items,
    total,
    isLoading,
    isError,
    isFetching,
    errorMessage,
    pagination,
    setPagination,
    statusGroupCounts,
  } = useAdminUploadManagementData(queryClient);

  return (
    <UploadManagement
      items={items}
      total={total}
      isLoading={isLoading}
      isError={isError}
      isFetching={isFetching}
      errorMessage={errorMessage}
      pagination={pagination}
      setPagination={setPagination}
      statusGroupCounts={statusGroupCounts}
    />
  );
};
